module.exports = __webpack_public_path__ + "img/replace_single.8be4e163.png";